import { AbstractControl, FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * { data: { construction_elements: ["fieldName1", "fieldName2"], sum: "100"}}
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function totalAddendCalculator(
  control: AbstractControl,
  form: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  let addends: any[] = [];
  let total: number = 0;

  // We add model values. If model is empty, we don't care
  if (model === undefined && !options && !options.data && !options.totalField) {
    return null;
  }

  // add all addends
  try {
    if (options.data) {
      addends = options.data;
    } else {
      // Collect all inputs of props.type="number"
      getElementsOfType(form?.parent?.parent?.fieldGroup as Array<FormlyFieldConfig>, addends);

      // Remove elements in exclusions from addends array
      let exclusions: string[] = [options.totalField];
      if (options.exclusions) {
        exclusions = [...exclusions, ...options.exclusions];
      }
      addends = addends.filter(function (el) {
        return exclusions.indexOf(el) < 0;
      });
    }

    addends.forEach((addendFieldName) => {
      const addCtrl = form?.parent?.formControl;
      const addCtrl1 = addCtrl ? addCtrl['controls'] : undefined;
      const addItem = addCtrl1 ? addCtrl1[addendFieldName] : undefined;
      if (addItem.value) {
        const addValue = addItem.value;
        const modelAddend = +addValue;
        total += modelAddend;
      }
    });

    // Change the totals control, but don't emit events or transmit change to parent
    if (options.totalField && form?.parent?.formControl instanceof FormGroup) {
      const addCtrl = form?.parent?.formControl;
      const addCtrl1 = addCtrl ? addCtrl['controls'] : undefined;
      const totalItem = addCtrl1 ? addCtrl1[options.totalField] : undefined;

      if (totalItem) {
        totalItem.patchValue(total);  
      }
    }
  } catch (error: any) {
    console.warn("totalCalculator exception "+error.toString());
  }

  return null;
}

export function getElementsOfType(
  fieldGroup: FormlyFieldConfig[],
  list: any[]
) {
  if (fieldGroup && fieldGroup.length > 0) {
    fieldGroup.forEach((field) => {
      if (field.key && field.props && field.props.type === 'number') {
        list.push(field.key);
      } else if (field.fieldGroup) {
        getElementsOfType(field.fieldGroup, list);
      }
    });
  }
}
